import { ajaxSend } from 'api/api';
const base = '/v1/flows';
export function addFlow(payload) {
    return ajaxSend({
        method: 'POST',
        path: base,
        data: payload.flow,
    });
}
export function getFlow(payload) {
    return ajaxSend({
        path: `${base}/${payload.id}`,
    });
}
export function removeFlow(payload) {
    return ajaxSend({
        method: 'DELETE',
        path: `${base}/${payload.id}`,
    });
}
export function updateFlow(payload) {
    return ajaxSend({
        method: 'PUT',
        path: `${base}/${payload.id}`,
        data: payload.flow,
    });
}
